import React from 'react';
import { useTranslation } from 'react-i18next'

interface PriceBreakdownModalProps {
  isOpen: boolean;
  toggle: () => void;
  t: (key: string) => string;
  cost: number;
  taxesData: { percentage: number }[];
  calculateTaxAmount: (cost: number, percentage: number) => number;
  taxAmount: number;
  platformFeeData: any;
  platformFeeAmounts: any;
  totalfee: number;
  taxtalfeegst: number;
  grantTotal: number;
  errors: Record<string, any>;
  submitted?: boolean;
  isDirty?: boolean;
  isCreatorLoading?: boolean;
  participantEdit?: boolean;
  // grantTotal: number;
  // setGrantTotal: (value: number) => void;
}

const PriceBreakdownModal: React.FC<PriceBreakdownModalProps> = ({
  cost,
  taxesData,
  calculateTaxAmount,
  taxAmount,
  platformFeeData,
  platformFeeAmounts,
  totalfee,
  taxtalfeegst,
  grantTotal,

}) => {
  const { t } = useTranslation()
  return (
    <div>

      <div className='px-5'>
        <table className="w-full border border-collapse border-black mb-4 font-semibold">
          <thead>

            <tr className="border border-black">
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-32 h-10">{t('normal')}</td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10"></td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10">{t('type')}</td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10">%</td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10">{t('amount')}</td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10">{t('net')}</td>
            </tr>

          </thead>
          <tbody>
            <tr className="border border-black-900">
              <td className="p-2 text-center border border-black w-32 h-10">{t('BaseAmount')}</td>
              <td className="p-2 text-center border border-black border-black w-24 h-10"></td>
              <td className="p-2 text-center border border-black border-black w-24 h-10"></td>
              <td className="p-2 text-center border border-black border-black w-24 h-10"></td>
              <td className="p-2 text-center border border-black border-black w-24 h-10"></td>
              <td className="p-2 text-center border border-black border-black w-24 h-10">{cost}</td>
            </tr>
          </tbody>
        </table>

        <table className="w-full border border-collapse border-black mb-4 font-semibold">
          <thead>

            <tr className="border border-black">
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-32 h-10">{t('taxCalculationOnBaseAmount')}</td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10"></td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10"></td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10"></td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10"></td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10"></td>
            </tr>

          </thead>
          <tbody>

            {taxesData.map((tax, index) => (
              <tr className="border border-black-900" key={index}>
                <td className="p-2 text-center border border-black w-32 h-10">{t('gst')}</td>
                <td className="p-2 text-center border border-black w-24 h-10"></td>
                <td className="p-2 text-center border border-black w-24 h-10">{t('included')}</td>
                <td className="p-2 text-center border border-black w-24 h-10">{tax.percentage}%</td>

                <td className="p-2 text-center border border-black w-24 h-10">₹{calculateTaxAmount(cost, tax.percentage)}</td>
                <td className="p-2 text-center border border-black w-24 h-10"></td>
              </tr>
            ))}


            <tr className="border border-black-900">
              <td className="p-2 text-center border border-black w-32 h-10"></td>
              <td className="p-2 text-center border border-black w-24 h-10">{t('totalTaxes')}</td>
              <td className="p-2 text-center border border-black w-24 h-10"></td>
              <td className="p-2 text-center border border-black w-24 h-10"></td>
              <td className="p-2 text-center border border-black w-24 h-10"></td>
              <td className="p-2 text-center border border-black w-24 h-10">₹ {taxAmount}</td>
            </tr>
          </tbody>
        </table>


        <table className="w-full border border-collapse border-black mb-4 font-semibold">
          <thead>

            <tr className="border border-black">
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-32 h-10">{t('platformFee')}</td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10"></td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10"></td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10"></td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10"></td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10"></td>
            </tr>

          </thead>

          <tbody>

            {platformFeeData?.map((fee: { platformFee_percentage: number; platformFee_name: string }, index: number) => {
              const feeAmount = platformFeeAmounts.find((f: { percentage: number; }) => f.percentage === fee.platformFee_percentage)?.amount || '0.00';

              return (
                <tr className="border border-black-900" key={index}>
                  <td className="p-0 text-center border border-black w-32 h-10">{fee.platformFee_name}</td>
                  <td className="p-2 text-center border border-black w-24 h-10"></td>
                  <td className="p-2 text-center border border-black w-24 h-10">{t('included')}</td>
                  <td className="p-2 text-center border border-black w-24 h-10">{fee.platformFee_percentage}% </td>
                  <td className="p-2 text-center border border-black w-24 h-10"> {isNaN(Number(totalfee)) || feeAmount == null ? '-' : (' ₹ ' + feeAmount)}</td>
                  <td className="p-2 text-center border border-black w-24 h-10"></td>
                </tr>
              );
            }
            )}

            <tr className="border border-black-900 ">
              <td className="p-2 text-center border border-black w-32 h-10"></td>
              <td className="p-2 text-center border border-black w-24 h-10">{t('totalFee')}</td>
              <td className="p-2 text-center border border-black w-24 h-10"></td>
              <td className="p-2 text-center border border-black w-24 h-10"></td>
              <td className="p-2 text-center border border-black w-24 h-10"></td>
              <td className="p-2 text-center border border-black w-24 h-10">{isNaN(Number(totalfee)) || totalfee == null ? '-' : (' ₹ ' + Number(totalfee).toFixed(2))}</td>
            </tr>

          </tbody>
        </table>


        <table className="w-full border border-collapse border-black mb-4 font-semibold">
          <thead>

            <tr className="border border-black">
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-32 h-10">{t('taxForPlatformFee')}</td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10"></td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10"></td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10"></td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10"></td>
              <td className="p-2 text-center bg-BeeMG-yellow border border-black w-24 h-10"></td>
            </tr>

          </thead>
          <tbody>

            {taxesData.map((tax, index) => (
              <tr className="border border-black-900" key={index}>
                <td className="p-2 text-center border border-black w-32 h-10">{t('gst')}</td>
                <td className="p-2 text-center border border-black w-24 h-10"></td>
                <td className="p-2 text-center border border-black w-24 h-10">{t('included')}</td>
                <td className="p-2 text-center border border-black w-24 h-10">{tax.percentage}%</td>

                <td className="p-2 text-center border border-black w-24 h-10">₹{calculateTaxAmount(totalfee, tax.percentage)}</td>
                <td className="p-2 text-center border border-black w-24 h-10"></td>
              </tr>
            ))}

            <tr className="border border-black-900">
              <td className="p-2 text-center border border-black w-32 h-10"></td>
              <td className="p-2 text-center border border-black w-24 h-10">{t('totalTaxes')}</td>
              <td className="p-2 text-center border border-black w-24 h-10"></td>
              <td className="p-2 text-center border border-black w-24 h-10"></td>
              <td className="p-2 text-center border border-black w-24 h-10"></td>
              <td className="p-2 text-center border border-black w-24 h-10"> ₹{taxtalfeegst}</td>
            </tr>
          </tbody>
        </table>
        <table className='w-full border border-collapse border-black mb-4 bg-BeeMG-yellow font-semibold'>
          <th className='text-left w-5/6 px-4 h-10 align-middle'>
            {t('totalAmount')}
          </th>
          <th className='text-right w-1/6 pr-4 h-10 align-middle'>
            {isNaN(Number(grantTotal)) || grantTotal == null ? '-' : (' ₹ ' + grantTotal)}
          </th>
        </table>
      </div>
      <div className='pr-6'>
      </div>
    </div>
  );
};

export default PriceBreakdownModal;
